import { TextButton } from "../../components/button/Button.tsx";
import Section from "../Section.tsx";
import { useNavigate } from "@solidjs/router";
import { useTranslation } from "../../state/i18n.tsx";
import { useCustomerState } from "../../state/customer.tsx";
import { useUserState } from "../../state/user.tsx";
import PageHeader from "../PageHeader.tsx";
import { Show } from "solid-js";
import Templates from "../customer/Templates.tsx";
import type { TemplateFilter } from "../customer/templateUtil.ts";
import { isDesktopViewport, isPhoneOrTabletDevice } from "../../utils/deviceUtil.ts";
import MobileWelcomeSection from "../MobileWelcomeSection.tsx";

const TemplatePage = () => {
  const { t, currentLanguage } = useTranslation();
  const customer = useCustomerState();
  const user = useUserState();
  const navigate = useNavigate();

  const navigateToOverview = () => {
    navigate(`/customers/${customer.customerId}`, { replace: true });
  };

  const shouldShowMobileWelcome = isPhoneOrTabletDevice() && !isDesktopViewport();

  return (
    <>
      <PageHeader
        title={t(($) => $.ONBOARDING_PAGE_COMPANY_WELCOME, { firstName: user().firstName })}
        subTitle={t(($) => $.ONBOARDING_PAGE_COMPANY_SETUP_ACCOUNT)}
        user={user()}
      />
      <Show
        when={!shouldShowMobileWelcome}
        fallback={
          <MobileWelcomeSection openPlatform={() => navigate(`/customers/${customer.customerId}`, { replace: true })} />
        }
      >
        <Section isTemplateSection fullHeight>
          <div class="flex h-full flex-col">
            <div class="flex-none">
              <h2 class="text-header-xl text-primary">{t(($) => $.ONBOARDING_PAGE_TEMPLATE_TITLE)}</h2>
              <p class="mb-6 text-medium-regular text-secondary">{t(($) => $.ONBOARDING_PAGE_TEMPLATE_SUBTITLE)}</p>
            </div>
            <div class="min-h-0 flex-1 overflow-y-auto pb-2">
              <Templates
                onboarding
                activeFilter={customer.settings.segment as TemplateFilter}
                language={currentLanguage()}
              />
            </div>
            <div class="shrink-0 border-t border-t-subtle pt-6">
              <TextButton
                text={t(($) => $.ONBOARDING_PAGE_TEMPLATE_SKIP)}
                variant="secondary"
                onClick={navigateToOverview}
              />
            </div>
          </div>
        </Section>
      </Show>
    </>
  );
};

export default TemplatePage;
